// extracted by mini-css-extract-plugin
export default {"card_container":"Card_card_container__Bffc9","status":"Card_status__M0cYn","cv_id":"Card_cv_id__FCMvf","name":"Card_name__PVlNF","edit_link":"Card_edit_link__NxKAx"};